// Homepage full page js
$(function(){
  
    var ww = $(window).width();
    var mySwiper = undefined;

    function initSwiper() {
    if (ww >= 768 && mySwiper == undefined) {
        mySwiper = new Swiper(".mySwiper-main", {
          speed: 500,
          direction: 'vertical',
          mousewheel: true,
          navigation: {
             nextEl: ".swiper-button-next-1",
             prevEl: ".swiper-button-prev-1",
          },
          pagination: {
              el: '.swiper-pagination-2',
              clickable: true,
          },
          watchOverflow : true,
            on: {
                  slideChange: function() {
                      chngClr(this);
                      setTimeout(function () {
                          mySwiper.params.touchReleaseOnEdges = false;  
                          mySwiper.params.mousewheel.releaseOnEdges = false;
                          $('.header-wrapper').addClass('change_bg');
                      });
                  },
                  reachEnd: function() {
                      setTimeout(function () {
                          mySwiper.params.touchReleaseOnEdges = true;
                          mySwiper.params.mousewheel.releaseOnEdges = true;
                      }, 500);
                  },
                  reachBeginning: function() {
                      setTimeout(function () {
                          mySwiper.params.touchReleaseOnEdges = true;
                          mySwiper.params.mousewheel.releaseOnEdges = true;
                          $('.header-wrapper').removeClass('change_bg');
                      }, 500);
                  }
              }
          });
        }
    }
    initSwiper();

    function chngClr(data){ 
      let slideCurrentIndex = data.activeIndex;
      let slideCurrent = data.slides[slideCurrentIndex];

      setTimeout(function(){
        $(slideCurrent).find(".cont").addClass("reUp");
        $(slideCurrent).siblings().find(".cont").removeClass("reUp");
      }, 300);

      if($(slideCurrent).hasClass("mainbotBk")){
        $(".swiper_paginate_main").addClass("bk");
        $(".custFooterMain").addClass("wh");
      } else {
        $(".swiper_paginate_main").removeClass("bk");
        $(".custFooterMain").removeClass("wh");
      }

      if($(slideCurrent).hasClass("lastItem")){ 
        $(".custFooterMain").addClass("addLine");
      } else {
        $(".custFooterMain").removeClass("addLine");
      }      
    }

    $(window).on('resize', function () {
    setTimeout(function(){
        ww = $(window).width();
        initSwiper();
    },15);
    });
  
    // Disable slide if one item show and hide Swiper paginations
    if($(".mySwiper-main .swiper-slide").length == 1) {
        $('.swiper-wrapper').addClass( "disabled" );
        $('.swiper_paginate_main').addClass( "disabled" );
    }
  
}); // End Homepage full page js

$(document).ready(function(){
  $(".cont").addClass("reUp");
});

// $(".ppopTrigger").click(function(){
//   let thisVal = $(this).attr("data-target");
//   $('#shopify-section-brand-popups').find(".brandPops").find(".popupMain").each(function(){
//     let thatVal = $(this).attr("data-element");
//     if(thisVal == thatVal){
//       $(this).show();
//     }
//   });
//   $(".popOverlay").show();
//   $("body").addClass("noScroll");
// });

// $(".closeIt").click(function(){
//   $(this).parent().hide();
//   $(".popOverlay").hide();
//   $("body").removeClass("noScroll");  
// });

document.addEventListener('DOMContentLoaded', function () {
  var mySwiper = new Swiper('.swiper-container', {
    direction: 'horizontal', // or 'vertical'
    loop: true,
    pagination: {
      el: '.swiper-pagination-1',
      clickable: true 
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 700,
    effect: "fade",
    fadeEffect: {
      crossFade: true       
    },
    on: {
      init: function() {
        myCallbackfunction(this, 500, 4000, 4500);
      },      
      slideChange: function() {
        myCallbackfunction(this, 1500, 4700, 4000);
      },
      sliderMove: function() {
        console.log("sliderMove");
        myCallbackfunction2(this, 1500, 4700, 4000);
      }
    }
    
  });

  function myCallbackfunction(data, textUp, imageZoom, slideDwn){
    let slideCurrentIndex = data.activeIndex;
    let slideCurrent = data.slides[slideCurrentIndex];

    $(slideCurrent).siblings().find("h2").removeClass("slideUp");
    $(slideCurrent).siblings().find("h5").removeClass("slideUp");
    $(slideCurrent).siblings().find("h2").removeClass("slideDown");
    $(slideCurrent).siblings().find("h5").removeClass("slideDown");    
    $(slideCurrent).siblings().find("img").css({"transform": "scale(1)", "opacity": "1"});

    setTimeout(function(){
      $(slideCurrent).find("h2").addClass("slideDown");
      $(slideCurrent).find("h5").addClass("slideDown");      
    }, slideDwn);    
    setTimeout(function(){
      $(slideCurrent).find("img").css({"transform": "scale(1.5)", "opacity": "0"});   
    }, imageZoom);
    setTimeout(function(){
      $(slideCurrent).find("h2").addClass("slideUp");
      $(slideCurrent).find("h5").addClass("slideUp");
    }, textUp);  
      
  }   

  function myCallbackfunction2(data, textUp, imageZoom, slideDwn){
    let slideCurrentIndex = data.activeIndex;
    let slideCurrent = data.slides[slideCurrentIndex];

    $(slideCurrent).siblings().find("h2").removeClass("slideUp");
    $(slideCurrent).siblings().find("h5").removeClass("slideUp");
    $(slideCurrent).siblings().find("h2").removeClass("slideDown");
    $(slideCurrent).siblings().find("h5").removeClass("slideDown");    
    $(slideCurrent).siblings().find("img").css({"transform": "scale(1)", "opacity": "1"});

    setTimeout(function(){
      $(slideCurrent).find("h2").addClass("slideDown");
      $(slideCurrent).find("h5").addClass("slideDown");      
    }, slideDwn);    
    setTimeout(function(){
      $(slideCurrent).find("img").css({"transform": "scale(1.5)", "opacity": "0"});   
    }, imageZoom);
    setTimeout(function(){
      $(slideCurrent).find("h2").addClass("slideUp");
      $(slideCurrent).find("h5").addClass("slideUp");
    }, textUp);  
      
  }     

});


